import { STATUS_CODES } from '@src/config/constant';
import secureStorage from '../../config/encrypt';
import { UserService } from '../../services/UserService';

import { createSlice , PayloadAction, Dispatch } from '@reduxjs/toolkit'

import { toast } from "react-toastify";

interface CaptchaData {
   // data: string; 
   data: {
    svg: string;
    value: string;
  }; 
}

export interface OtpResponse {
    data: {
      status: number;
      message: string;
      user_id: string;
    };
  }

 export interface DeleteAccount {
    // Define the structure of the 'params' object here
    email: string;
    otp : string;
  }

  export interface ChangePassword {
    // Define the structure of the 'params' object here
    otp : string;
    password: string;
  }

  export interface CreateNewPassword {
    // Define the structure of the 'params' object here
    email: string;
    password: string;
    confirm_password: string;
  }

interface OtpRequest {
    name?:string
    email: string;
    password?: string;
    captcha?: string;
    resendOtp?: boolean;
    source?:string
    logintype?:string
}

interface LoginRequest {
    email: string;
    password?: string; 
    captcha?: string; 
    hash ?: string;
    source: string;
}

interface UserState {
    authUser: any; // Replace 'any' with the appropriate type for 'authUser'
    login: boolean;
    redirectTo: string;
    cities: any[]; // Replace 'any[]' with the appropriate type for 'cities'
  }
  
interface DuplicateCheckRequest {
    // Define the structure of the 'params' object here
    email?: string;
    mobile?: string;
    ktp_id?: string;
    npwp_no?: string;
    account_no?: string;
    referral?: string;
  }

  interface SendOtpToRegistrationRequest {
    // Define the structure of the 'params' object here
    email: string;
    source?: string;
    captcha?: string;
    hash?: string;
  }

  interface RegisterRequest {
    // Define the structure of the 'params' object here
    email: string;
    name: string;
    mobile: string;
    source?: string;
    captcha?: string;
    hash?: string;
    [key: string]: any;
  }
  
const user = createSlice({
    name: 'user',
    initialState: {
      authUser: null, // Set the initial value for 'authUser' to null or the appropriate initial value
      login: false,
      redirectTo: '/',
      cities: []
    } as UserState,
    reducers: {
        loginSuccess: (state, action: PayloadAction<any>) => {
            state.authUser = action.payload;
            state.login = true;
            state.redirectTo = '/'

        }
    },
});

export default user.reducer;

const { loginSuccess  } = user.actions

export const loadloginCaptcha = () => {
    return new Promise<CaptchaData>((resolve, reject) => {
        UserService.loginCaptcha()
            .then(
                captcha => { resolve(captcha?.data) },
                error => {
                    reject(error)
                }
            )
    })
}


export const LoginHandler = async (params: LoginRequest, dispatch: Dispatch): Promise<OtpResponse> => {

    return new Promise((resolve, reject) => {
        UserService.Login(params)
            .then(
                user => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {

                        let ob = user.data.data;

                        secureStorage.setItem('authAgentUserInfo', ob);
                        toast.success(user.data.message);
                        dispatch(loginSuccess(ob));
                        resolve(user.data)
                    }
                    else {
                        toast.error(user.data.message);
                        resolve(user && user.data)
                    }
                },
                error => {
                    reject(error);
                }
            );
    });
}

export const googleWithLogin = async (params: OtpRequest, dispatch: Dispatch): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.googleWithLogin(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        let ob = user.data.data;

                        secureStorage.setItem('authAgentUserInfo', ob);
                        toast.success(user.data.message);
                        dispatch(loginSuccess(ob));
                        resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}


export const createOtp = (params: OtpRequest): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.createOtp(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}

export const VerifyOtpHandler = async (params: OtpRequest, dispatch: Dispatch): Promise<OtpResponse> => {

    return new Promise((resolve, reject) => {
        UserService.VerifyOtp(params)
            .then(
                user => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {

                        // toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user.data.message);
                        resolve(user && user.data)
                    }
                },
                error => {
                    reject(error);
                }
            );
    });
}

export const sendOtpToDeleteAccount = (params: OtpRequest): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.SendOtpToDeleteAccount(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}

export const deleteAccountRequest = (params: DeleteAccount): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.deleteAccount(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}


export const sendOtpToForgotPassword = (params: OtpRequest): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.sendOtpToForgotPassword(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}

export const otpVerifiedToForgotPassword = (params: DeleteAccount,showToast: boolean = true): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.otpVerifiedToForgotPassword(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        if (showToast) {
                            toast.success(user.data.message);
                        }
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });
}

export const verifyOtpPassword = (params: ChangePassword,showToast: boolean = true): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.verifyOtpPassword(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        if (showToast) {
                            toast.success(user.data.message);
                        }
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });
}

export const addNewPasswordToForgotPassword = (params: CreateNewPassword,showToast: boolean = true): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.addNewPasswordToForgotPassword(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        if(showToast){
                            toast.success(user.data.message);
                        }
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });
}



export const deleteAccountRequestID = (params: any): Promise<any> => {

    return new Promise<any>((resolve, reject) => {
        UserService.deleteAccountID(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}

export const duplicateCheck = (params: DuplicateCheckRequest, showToast: boolean = true): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.duplicateCheck(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        if (showToast) {
                            toast.success(user.data.message);
                        }
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}

export const sendOtpToRegistration = (params: SendOtpToRegistrationRequest): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.sendOtpToRegistration(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}

export const register = (params: RegisterRequest): Promise<OtpResponse> => {

    return new Promise<OtpResponse>((resolve, reject) => {
        UserService.register(params)
            .then(
                (user: any) => {
                    if (user && user.data && user.data.status === STATUS_CODES['success']) {
                        toast.success(user.data.message);
                        return resolve(user.data)
                    }
                    else {
                        toast.error(user?.data?.message);
                        return resolve(user && user?.data)
                    }

                },
                error => {
                    reject(error);
                }
            );
    });

}
